module.exports = __webpack_public_path__ + "img/facebook_number_cn.e50fcef9.svg";